<script setup lang="ts">
import { CircleHelp, ShieldCheck } from 'lucide-vue-next'
</script>

<template>
  <div class="h5-shell">
    <header class="h5-header">
      <router-link class="h5-brand" to="/try" aria-label="BondPet 轻试玩">
        <span aria-hidden="true">B</span>
        <strong>BondPet</strong>
      </router-link>
      <nav aria-label="辅助导航">
        <router-link to="/help/start"><CircleHelp :size="18" aria-hidden="true" />帮助</router-link>
        <router-link to="/consent"><ShieldCheck :size="18" aria-hidden="true" />隐私</router-link>
      </nav>
    </header>
    <main id="main-content" tabindex="-1">
      <router-view />
    </main>
  </div>
</template>
